function c(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
export {
  c as default
};
